import axios from 'axios';

export const matrizApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/matriz`,
    headers: {
        'Content-Type': 'application/json'
    }
})